import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_warehouse_inventory_analytics: { message: "idle" },
};

export const retrieve_warehouse_inventory_analytics_Slice = createSlice({
 name: "retrieve_warehouse_inventory_analytics",
 initialState,
 reducers: {
  success_retrieve_warehouse_inventory_analytics: (state, action) => {
   state.retrieve_warehouse_inventory_analytics = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_warehouse_inventory_analytics: (state, action) => {
   state.retrieve_warehouse_inventory_analytics = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_warehouse_inventory_analytics: (state) => {
   state.retrieve_warehouse_inventory_analytics = { status: app_consts.IDLE };
  },
  loading_retrieve_warehouse_inventory_analytics: (state) => {
   state.retrieve_warehouse_inventory_analytics = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_warehouse_inventory_analytics, fail_retrieve_warehouse_inventory_analytics, reset_retrieve_warehouse_inventory_analytics, loading_retrieve_warehouse_inventory_analytics } = retrieve_warehouse_inventory_analytics_Slice.actions;

export default retrieve_warehouse_inventory_analytics_Slice.reducer;